import { useState } from "react";

export function useGovernanceApplicability() {
  const [effectiveFrom, setEffectiveFrom] = useState("");
  const [applicabilityRevisionId, setApplicabilityRevisionId] = useState("");
  const [publicationConsent, setPublicationConsent] = useState(true);

  return {
    effectiveFrom,
    setEffectiveFrom,
    applicabilityRevisionId,
    setApplicabilityRevisionId,
    publicationConsent,
    setPublicationConsent,
  };
}
